module.exports = __webpack_public_path__ + "static/media/car_placeholder.3104baf2.png";